import createIcon from '../../createIcon';

/**
 * @component @name LeakAdd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAzSDNWNkM0LjY2IDYgNiA0LjY2IDYgM1pNMTQgM0gxMkMxMiA3Ljk3IDcuOTcgMTIgMyAxMlYxNEM5LjA4IDE0IDE0IDkuMDcgMTQgM1pNMTAgM0g4QzggNS43NiA1Ljc2IDggMyA4VjEwQzYuODcgMTAgMTAgNi44NyAxMCAzWk0xMCAyMUgxMkMxMiAxNi4wMyAxNi4wMyAxMiAyMSAxMlYxMEMxNC45MyAxMCAxMCAxNC45MyAxMCAyMVpNMTggMjFIMjFWMThDMTkuMzQgMTggMTggMTkuMzQgMTggMjFaTTE0IDIxSDE2QzE2IDE4LjI0IDE4LjI0IDE2IDIxIDE2VjE0QzE3LjEzIDE0IDE0IDE3LjEzIDE0IDIxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LeakAdd = createIcon('LeakAdd', [
  [
    'path',
    {
      d: 'M6 3H3V6C4.66 6 6 4.66 6 3ZM14 3H12C12 7.97 7.97 12 3 12V14C9.08 14 14 9.07 14 3ZM10 3H8C8 5.76 5.76 8 3 8V10C6.87 10 10 6.87 10 3ZM10 21H12C12 16.03 16.03 12 21 12V10C14.93 10 10 14.93 10 21ZM18 21H21V18C19.34 18 18 19.34 18 21ZM14 21H16C16 18.24 18.24 16 21 16V14C17.13 14 14 17.13 14 21Z',
      key: '1mny7b',
    },
  ],
]);

export default LeakAdd;
